import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData, postData } from 'src/utils/axios/serverHelper';
import { formatDate } from 'src/utils/string/stringUtil';
import { TQC2010_R01DetailDto, TQC2010_R01Dto, TQC2010_R01HeaderDto } from './Dto_TQC2010_R01';
import { TQC2010_R01Filter } from './Store_TQC2010_R01';

const baseUrl = `${config.apiUrl}/TQC2010_R01`;

const getParams = (filter: Partial<TQC2010_R01Filter>, listLength: number = 0) => ({
	compCd: filter.compCd || undefined,
	workplaceCd: filter.workplaceCd || undefined,
	jobTeam: filter.jobTeam || undefined,
	workEmp: filter.workEmp || undefined,
	inspectType: filter.inspectType || undefined,
	itemCd: filter.itemCd || undefined,
	productOrderNo: filter.productOrderNo || undefined,
	startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
	endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
	listLength: listLength || 0,
});

/** 품질검사 항목별 목록 조회 (검사구분 필터 포함) */
export const getTQC2010_R01List = async (
	option: string,
	params: Partial<TQC2010_R01Filter>,
	listLength: number = 0,
) => getData<ResponseDto<TQC2010_R01HeaderDto[]>>(`${baseUrl}/${option}`, {
	params: getParams(params, listLength),
});

/** 품질검사 항목별 전체 건수 조회 */
export const getTQC2010_R01AllCount = async (params: Partial<TQC2010_R01Filter>) =>
	getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params: getParams(params, 0) });

/** 품목별 검사항목 상세 목록 조회 (검사구분 + 작업지시 기준 기존 검사결과 병합) */
export const getTQC2010_R01DetailList = async (
	itemCd: string,
	productOrderNo: string,
	inspectType: string,
) => getData<ResponseDto<TQC2010_R01DetailDto[]>>(`${baseUrl}/detail`, {
	params: { itemCd, productOrderNo, inspectType },
});

/** 검사결과 저장 (동일 작업지시+품목+검사구분+검사항목이면 갱신) */
export const saveTQC2010_R01 = async (request: TQC2010_R01Dto) =>
	postData<TQC2010_R01Dto, ResponseDto<void>>(baseUrl, request);
